'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'people-pulling';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e535';
var svgPathData = 'M104 56A24 24 0 1 0 56 56a24 24 0 1 0 48 0zM24 56a56 56 0 1 1 112 0A56 56 0 1 1 24 56zm9.5 113.3c-.9 2-1.5 4.3-1.5 6.7l0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 176c0-26.5 21.5-48 48-48l62.6 0c16.7 0 32.9 5.2 46.5 14.9l121.7 86.8c11.8-33.4 35.5-61.5 66.9-78.6l12.7-6.9c19.4-10.6 41.2-16.2 63.4-16.2c36.9 0 69.7 23.6 81.4 58.7l17.1 51.4c3.4 10.1 10 18.8 18.9 24.8l29.7 19.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-29.7-19.8c-14.8-9.9-25.9-24.4-31.5-41.3l-8.8-26.4L443.3 331l43.6 37.8c4.7 4.1 8.1 9.4 9.8 15.4l30.7 107.4c2.4 8.5-2.5 17.4-11 19.8s-17.4-2.5-19.8-11L465.9 393 365.4 305.8c-14.4-12.5-20.1-32.4-14.4-50.6l26.6-85c-1.3 .6-2.6 1.3-3.9 2l-12.7 6.9c-27.5 15-47.4 40.8-55 71.2l-2.3 9.2c-.2 1-.5 1.9-.9 2.8c-.8 2-2.1 3.7-3.5 5.1c-3.3 3.2-7.8 4.9-12.5 4.5c-1.9-.2-3.8-.6-5.5-1.5c-1-.5-1.9-1-2.7-1.6L148.2 175.9l75.3 316.4c2 8.6-3.3 17.2-11.9 19.3s-17.2-3.3-19.3-11.9L157.3 352l-56.4 0 26.9 141c1.7 8.7-4 17.1-12.7 18.7s-17.1-4-18.7-12.7L33.5 169.3zm79-5.6c-.3-1.2-.4-2.5-.4-3.7c-.5 0-.9 0-1.4 0l-46.3 0L94.8 320l54.9 0L112.4 163.7zM480 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 400 56zM381.5 264.8c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 45-130c-10-11.5-24.7-18.4-40.6-18.4c-2.5 0-5 .1-7.5 .3L381.5 264.8zm-6.4 88.9c7.9 4 11.1 13.6 7.2 21.5l-30.8 61.7c-1.5 3.1-3.6 5.9-6 8.3l-62.2 62.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l62.2-62.2 30.8-61.7c4-7.9 13.6-11.1 21.5-7.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPeoplePulling = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;